import React from 'react';
import { Box, Typography } from '@mui/material';
import { getPushNotificationPresentation } from '../../utils/pushNotificationPresentation';

/**
 * Push-only row: event icon + title + time (no actor — not available on FCM).
 */
const PushNotificationCompactRow = ({ payload, title, timeLabel = 'Now' }) => {
  const { Icon, accentColor } = getPushNotificationPresentation(payload);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        minWidth: 0,
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: 1,
          bgcolor: `${accentColor}14`,
          color: accentColor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Icon sx={{ fontSize: 20 }} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, minWidth: 0 }}>
          <Typography
            variant="body2"
            sx={{
              flex: 1,
              minWidth: 0,
              fontWeight: 700,
              fontSize: '0.875rem',
              lineHeight: 1.25,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: 'text.primary',
            }}
          >
            {title}
          </Typography>
          {timeLabel ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ flexShrink: 0, fontSize: '0.7rem', lineHeight: 1.25 }}
            >
              {timeLabel}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default PushNotificationCompactRow;
